import { ReactNode } from 'react';
import styled from 'styled-components';

export interface WorkflowLabelProps {
  label: string;
  text: ReactNode;
  className?: string;
  labelFullWidth?: boolean;
}

export const WorkflowLabel = styled(({ label, text, className }: WorkflowLabelProps) => {
  return (
    <p className={className}>
      <strong>{label}</strong> {text}
    </p>
  );
})`
  & strong {
    display: ${({ labelFullWidth }) => (labelFullWidth ? 'block' : 'inline-block')};
    width: 110px;
  }
`;

WorkflowLabel.defaultProps = {
  labelFullWidth: false,
};
